<template>
  <RewardsForm />
</template>

<script>
import RewardsForm from '../components/RewardsForm.vue'

export default {
  components: { RewardsForm },
}
</script>
